import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

import { useLocation, useNavigate } from "react-router-dom";
// Assurez-vous que le chemin est correct
import "./index.scss"; // Import du fichier SCSS

import logo from "../../../assets/images/logo-a.png"; // Assurez-vous que le chemin est correct
import { BergerIcon } from "../../../assets/icons/BergerIcon";
import { UserIcon } from "../../../assets/icons/UserIcon";
import { CartIcon } from "../../../assets/icons/CartIcon";
import { FaTimes } from "react-icons/fa";
import CategoryService from "../../../services/category";
import { showErrorToaster } from "../../../adminCompenents/listComponents/UI/toaster/error";
import logo1 from "../../../assets/images/logoF.png";
import { useCart } from "../../../context/CartContext";
import { useClientAuth } from "../../../context/ClientAuthContext";
const categoryService = new CategoryService();
// Assurez-vous que le chemin est correct
const Header = () => {
  const location = useLocation();
  const [categories, setCategories] = useState([]);
  const [activeMenu, setActiveMenu] = useState(location.pathname);
  console.log("location.pathname", location.pathname); // Initialise avec la route actuelle
  const searchParams = new URLSearchParams(location.search);
  const currentCategory = searchParams.get("category");
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdownM, setShowDropdownM] = useState(false);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const { cartItems } = useCart();
  const { currentClient, handleClientLogout } = useClientAuth();

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 768); // Mobile : ≤ 768px
    };
    handleResize(); // Vérifie la taille au chargement
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [showModal, setShowModal] = useState(false);
  const toggleModal = () => {
    setShowModal(!showModal);
    setShowDropdownM(false);
  };

  const handleLogout = async () => {
    await handleClientLogout();
    navigate("/");
  };

  const navVariants = {
    hidden: { opacity: 0, x: 100 }, // Départ : Hors écran à droite
    visible: {
      opacity: 1,
      x: 0, // Fin : À sa position d'origine
      transition: { duration: 1, ease: "easeOut" }, // Durée et effet
    },
  };
  // ⚡ Load categories
  const loadData = async () => {
    setIsLoading(true);
    try {
      const res = await categoryService.getAllCategories();
      setCategories(res?.data);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);
  return (
    <header className="header-container ">
      <div className=" w-100 d-flex justify-content-between align-items-center">
        {/* Logo Section */}

        {isMobile ? (
          <>
            <div className="logo-mobile" onClick={() => navigate("/")}>
              <img src={logo1} />
            </div>
            <div className="mobile-actions">
              {currentClient ? (
                <button
                  className="btn-icon user-profile-btn"
                  onClick={() => navigate("/profile")}>
                  <UserIcon />
                </button>
              ) : (
                <></>
              )}
              <button
                className="btn-cart mobile-cart-btn"
                onClick={() => navigate("/cart-page")}>
                <CartIcon />
                <span className="cart-badge">{cartItems.length}</span>
              </button>
              <button onClick={toggleModal} className="icon-btn">
                <BergerIcon />
              </button>
            </div>
          </>
        ) : (
          <div className=" w-100 d-flex justify-content-between align-items-center">
            <div className="logo" onClick={() => navigate("/")}>
              <img src={logo1} />
            </div>
            <nav className="nav-links w-100  d-flex justify-content-center align-items-center">
              {categories.map((row) => (
                <a
                  href={`/all-products?category=${row._id}`}
                  className={`nav-link  ${
                    currentCategory === row._id ? "active" : ""
                  }`}>
                  {row?.title}
                </a>
              ))}

              <a
                href="/contact"
                className={`nav-link  ${
                  activeMenu === "/contact" ? "active" : ""
                }`}>
                CONTACT
              </a>
            </nav>
            <div className="d-flex justify-content-center align-items-center ">
              {currentClient ? (
                <button
                  className="btn-icon user-profile-btn"
                  onClick={() => navigate("/profile")}>
                  <UserIcon />
                </button>
              ) : (
                <div className="auth-buttons">
                  <button
                    className="btn-auth btn-login"
                    onClick={() => navigate("/login-page")}>
                    CONNEXION
                  </button>
                  <button
                    className="btn-auth btn-register me-3"
                    onClick={() => navigate("/register")}>
                    S'INSCRIRE
                  </button>
                </div>
              )}
              <button
                className="btn-cart"
                onClick={() => navigate("/cart-page")}>
                {" "}
                <CartIcon />{" "}
                <span className="cart-badge">{cartItems.length}</span>
              </button>
            </div>
          </div>
        )}
        {/* Navigation Links */}
      </div>
      <Modal
        show={showModal}
        onHide={toggleModal}
        dialogClassName="fade-right"
        className="mm-kra">
        <Modal.Body>
          <div className="mobile-menu-content">
            <div className="mobile-menu-header">
              <div className="mobile-brand">
                <img src={logo1} />
              </div>
              <button className="mobile-menu-close-btn" onClick={toggleModal}>
                <FaTimes size={20} />
              </button>
            </div>

            <nav className="mobile-nav-links">
              {categories.map((row) => (
                <a
                  href={`all-products?category=${row._id}`}
                  className={`mobile-nav-link  ${
                    currentCategory === row._id ? "active" : ""
                  }`}>
                  {row?.title}
                </a>
              ))}

              <a href="/contact" className="mobile-nav-link">
                CONTACT
              </a>
            </nav>

            <div className="mobile-menu-actions">
              {currentClient ? (
                <>
                  <div className="mobile-menu-user-info">
                    <div className="mobile-menu-user-name">
                      Bonjour, {currentClient.name || currentClient.email}
                    </div>
                  </div>
                  <button
                    className="mobile-menu-btn mobile-menu-btn-profile"
                    onClick={() => {
                      navigate("/profile");
                      toggleModal();
                    }}>
                    <UserIcon />
                    <span>MON PROFIL</span>
                  </button>
                  <button
                    className="mobile-menu-btn mobile-menu-btn-logout"
                    onClick={() => {
                      handleLogout();
                      toggleModal();
                    }}>
                    SE DÉCONNECTER
                  </button>
                </>
              ) : (
                <>
                  <button
                    className="mobile-menu-btn mobile-menu-btn-login"
                    onClick={() => {
                      navigate("/login-page");
                      toggleModal();
                    }}>
                    CONNEXION
                  </button>
                  <button
                    className="mobile-menu-btn mobile-menu-btn-register"
                    onClick={() => {
                      navigate("/register");
                      toggleModal();
                    }}>
                    INSCRIPTION
                  </button>
                </>
              )}
              <button
                className="mobile-menu-btn mobile-menu-btn-cart"
                onClick={() => {
                  navigate("/cart-page");
                  toggleModal();
                }}>
                <CartIcon />
                <span>PANIER ({cartItems.length})</span>
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </header>
  );
};

export default Header;
